import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid lg:grid-cols-3 gap-2 lg:gap-5" }

import { pb } from "@/pocketbase";
import Title from "@/components/Title.vue";
import LinkBox from "@/components/LinkBox.vue";
import { Initiative } from "@/model";
import Divider from "@/components/Divider.vue";
import Content from "@/components/Content.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'InitiativesView',
  async setup(__props) {

let __temp: any, __restore: any

const initiatives = (
  ([__temp,__restore] = _withAsyncContext(() => pb.collection('initiatives').getFullList<Initiative>(null, {
  sort: '-startDate',
}))),
  __temp = await __temp,
  __restore(),
  __temp
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Title, null, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("Initiatives")
      ])),
      _: 1,
      __: [0]
    }),
    _createVNode(Divider),
    _createVNode(Content, null, {
      default: _withCtx(() => [
        _cache[1] || (_cache[1] = _createElementVNode("p", null, " Overview of group-wide initiatives and special interest groups (SIG). ", -1)),
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(initiatives), (initiative) => {
            return (_openBlock(), _createBlock(LinkBox, {
              route: "initiative",
              routeParams: { slug: initiative.slug },
              title: initiative.name,
              description: initiative.abstract
            }, null, 8, ["routeParams", "title", "description"]))
          }), 256))
        ])
      ]),
      _: 1,
      __: [1]
    })
  ], 64))
}
}

})